import {RefObject, useEffect, useRef, useState} from 'react'

export const useUpdateEffect: typeof useEffect = (effect, deps) => {
  const isFirstMountRef = useRef(false)

  useEffect(() => {
    if (!isFirstMountRef.current) {
      isFirstMountRef.current = true
    } else {
      return effect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}

export const useFloatingHeader = (ref: RefObject<HTMLElement>, threshold = 1): boolean => {
  const [isFloat, setFloat] = useState(false)

  useEffect(() => {
    const element = ref.current

    const observer = new IntersectionObserver(
      ([e]) => {
        setFloat(!e?.isIntersecting)
      },
      {threshold},
    )
    if (element) {
      observer.observe(element)

      return () => observer.unobserve(element)
    }
  }, [ref, threshold])

  return isFloat
}
